import React, { Component } from 'react'

import Panzoom from '@/services/panzoom/Panzoom'
import { getAttachmentType } from '@/helpers/attachments'

import './MessageAttachmentsSectionViewer.sass'

class MessageAttachmentsSectionViewer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentAttachment: props.attachment
    }

    this.onKeyPressEvent = (e) => {
      if (e.key === 'ArrowRight' && this.getIndexOfCurrentAttachment() !== this.props.allAttachments.length - 1) {
        this.nextAttachment()
      } else if (e.key === 'ArrowLeft' && this.getIndexOfCurrentAttachment() !== 0) {
        this.previousAttachment()
      } else if (e.key === 'Backspace' || e.key === 'Escape') {
        this.props.closeModal()
      }
    }
    this.onEscapePressEvent = (e) => {
      if (e.key === 'Backspace' || e.key === 'Escape') {
        this.props.closeModal()
      }
    }
  }

  componentDidMount () {
    document.addEventListener('keydown', this.onKeyPressEvent, false)
    document.querySelector('.ReactModal__Overlay')?.addEventListener('keydown', this.onEscapePressEvent, false)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.onKeyPressEvent, false)
    document.querySelector('.ReactModal__Overlay')?.removeEventListener('keydown', this.onEscapePressEvent, false)
  }

  getIndexOfCurrentAttachment () {
    const { props: { allAttachments }, state: { currentAttachment } } = this
    return allAttachments.findIndex(attachment => attachment.id === currentAttachment.id)
  }

  previousAttachment () {
    this.setState({ currentAttachment: this.props.allAttachments[this.getIndexOfCurrentAttachment() - 1] })
  }

  nextAttachment () {
    this.setState({ currentAttachment: this.props.allAttachments[this.getIndexOfCurrentAttachment() + 1] })
  }

  getHeader (attachment) {
    return <>
      <div className="-viewer-label">
        {attachment.filename}
      </div>
      { this.getIndexOfCurrentAttachment() !== 0 && <button className="navigation-button -left" onClick={() => this.previousAttachment()} />}
    </>
  }

  getFooter (attachment) {
    return <div>
      { this.getIndexOfCurrentAttachment() !== this.props.allAttachments.length - 1 && <button className="navigation-button -right" onClick={() => this.nextAttachment()} /> }
      <a className="-download-button" href={attachment.uri} rel="noopener noreferrer">
      </a>
    </div>
  }

  iframe (attachment) {
    return <div className="-iframe-viewer">
      {this.getHeader(attachment)}
      <iframe className="-iframe-viewer" src={attachment.uri} />
      {this.getFooter(attachment)}
    </div>
  }

  image (attachment) {
    let panZoom
    const createPanzoom = (el) => {
      if (el) panZoom = new Panzoom(el)
    }

    const zoomIn = () => {
      panZoom.zoomIn()
    }

    const zoomOut = () => {
      panZoom.zoomOut()
    }
    
    return <div className="-image-viewer">
      {this.getHeader(attachment)}
      <div className="-image-viewer-container">
        <img src={attachment.uri} alt={attachment.filename} ref={createPanzoom} />
      </div>
      {this.getFooter(attachment)}
      <div className="zoom-menu">
        <div className="zoom-menu__container">
          <button className="zoom-menu__zoom-out" onClick={zoomOut} />
          <button className="zoom-menu__zoom-in" onClick={zoomIn}></button>
        </div>
      </div>
    </div>
  }

  render () {
    const { state: { currentAttachment } } = this
    const type = getAttachmentType(currentAttachment.mimetype)
    if (type === 'image') return this.image(currentAttachment)
    if (type === 'pdf') return this.iframe(currentAttachment)
    return <div>
      {this.getHeader(currentAttachment)}
      {this.getFooter(currentAttachment)}
    </div>
  }
}

export default MessageAttachmentsSectionViewer
